// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.StepList-block-IA8da {
  --red: #e8232b;
  --green: #16a34a;
  --ink: #0f1214;
  --muted: #5a6168;
  font-family: 'Inter', -apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, sans-serif;
  color: #0f1214;
  color: var(--ink);
}

.StepList-heading-C6O76 {
  font-size: clamp(22px, 3.4vw, 30px);
  font-weight: 800;
  margin: 0 0 28px;
}

.StepList-row-UChWP {
  display: grid;
  grid-template-columns: repeat(3, 1fr);
  grid-template-columns: repeat(var(--cols, 3), 1fr);
  gap: 26px;
  margin: 0;
  padding: 0;
  list-style: none;
  counter-reset: step;
}

.StepList-step-f4eO2 {
  text-align: left;
}

.StepList-no-g1w9I {
  width: 46px;
  height: 46px;
  border-radius: 999px;
  background: var(--red);
  color: #fff;
  font-weight: 800;
  font-size: 20px;
  display: -webkit-box;
  display: -ms-flexbox;
  display: flex;
  -webkit-box-align: center;
      -ms-flex-align: center;
          align-items: center;
  -webkit-box-pack: center;
      -ms-flex-pack: center;
          justify-content: center;
  margin: 0 0 14px;
}

.StepList-green-Kpe2b .StepList-no-g1w9I {
  background: var(--green);
}

.StepList-icon-qkf2u {
  width: 24px;
  height: 24px;
}

.StepList-title-ZNom4 {
  font-size: 18px;
  font-weight: 800;
  margin: 0 0 6px;
}

.StepList-text-UqXaB {
  font-size: 15px;
  line-height: 1.55;
  color: var(--muted);
  margin: 0;
}

@media (max-width: 720px) {
  .StepList-row-UChWP {
    grid-template-columns: 1fr;
    gap: 22px;
  }
}

@media (prefers-color-scheme: dark) {
  .StepList-block-IA8da {
    color: #f3f4f6;
  }
  .StepList-heading-C6O76,
  .StepList-title-ZNom4 {
    color: #f3f4f6;
  }
  .StepList-text-UqXaB {
    color: #9aa3ad;
  }
}
`, "",{"version":3,"sources":["webpack://./src/components/marketing/StepList.css"],"names":[],"mappings":"AAAA;EACE,cAAc;EACd,gBAAgB;EAChB,cAAc;EACd,gBAAgB;EAChB,uFAAuF;EACvF,cAAiB;EAAjB,iBAAiB;AACnB;;AAEA;EACE,mCAAmC;EACnC,gBAAgB;EAChB,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,qCAAkD;EAAlD,kDAAkD;EAClD,SAAS;EACT,SAAS;EACT,UAAU;EACV,gBAAgB;EAChB,mBAAmB;AACrB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,oBAAoB;EACpB,sBAAsB;EACtB,WAAW;EACX,gBAAgB;EAChB,eAAe;EACf,oBAAa;EAAb,oBAAa;EAAb,aAAa;EACb,yBAAmB;MAAnB,sBAAmB;UAAnB,mBAAmB;EACnB,wBAAuB;MAAvB,qBAAuB;UAAvB,uBAAuB;EACvB,gBAAgB;AAClB;;AACA;EACE,wBAAwB;AAC1B;;AACA;EACE,WAAW;EACX,YAAY;AACd;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,eAAe;AACjB;;AACA;EACE,eAAe;EACf,iBAAiB;EACjB,mBAAmB;EACnB,SAAS;AACX;;AAEA;EACE;IACE,0BAA0B;IAC1B,SAAS;EACX;AACF;;AAEA;EACE;IACE,cAAc;EAChB;EACA;;IAEE,cAAc;EAChB;EACA;IACE,cAAc;EAChB;AACF","sourcesContent":[".block {\n  --red: #e8232b;\n  --green: #16a34a;\n  --ink: #0f1214;\n  --muted: #5a6168;\n  font-family: 'Inter', -apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, sans-serif;\n  color: var(--ink);\n}\n\n.heading {\n  font-size: clamp(22px, 3.4vw, 30px);\n  font-weight: 800;\n  margin: 0 0 28px;\n}\n\n.row {\n  display: grid;\n  grid-template-columns: repeat(var(--cols, 3), 1fr);\n  gap: 26px;\n  margin: 0;\n  padding: 0;\n  list-style: none;\n  counter-reset: step;\n}\n\n.step {\n  text-align: left;\n}\n\n.no {\n  width: 46px;\n  height: 46px;\n  border-radius: 999px;\n  background: var(--red);\n  color: #fff;\n  font-weight: 800;\n  font-size: 20px;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  margin: 0 0 14px;\n}\n.green .no {\n  background: var(--green);\n}\n.icon {\n  width: 24px;\n  height: 24px;\n}\n\n.title {\n  font-size: 18px;\n  font-weight: 800;\n  margin: 0 0 6px;\n}\n.text {\n  font-size: 15px;\n  line-height: 1.55;\n  color: var(--muted);\n  margin: 0;\n}\n\n@media (max-width: 720px) {\n  .row {\n    grid-template-columns: 1fr;\n    gap: 22px;\n  }\n}\n\n@media (prefers-color-scheme: dark) {\n  .block {\n    color: #f3f4f6;\n  }\n  .heading,\n  .title {\n    color: #f3f4f6;\n  }\n  .text {\n    color: #9aa3ad;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"block": `StepList-block-IA8da`,
	"heading": `StepList-heading-C6O76`,
	"row": `StepList-row-UChWP`,
	"step": `StepList-step-f4eO2`,
	"no": `StepList-no-g1w9I`,
	"green": `StepList-green-Kpe2b`,
	"icon": `StepList-icon-qkf2u`,
	"title": `StepList-title-ZNom4`,
	"text": `StepList-text-UqXaB`
};
module.exports = ___CSS_LOADER_EXPORT___;
